
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/new",
      function () {
        return require("private-next-pages/project/new/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/new"])
      });
    }
  